import { db as dbCore } from "@budibase/backend-core"

export async function appExists(appId: string) {
  const allAppIds = (await dbCore.getAllApps({
    all: true,
    idsOnly: true,
  })) as string[]
  return allAppIds.includes(appId)
}
